"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InputValidator = void 0;
var React = __importStar(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var icons_1 = require("@tiendanube/icons");
var validator_1 = require("../validator");
var Text_1 = __importDefault(require("../Text"));
require("./Input.css");
var Spinner_1 = require("../Spinner");
function Input(_a) {
    var name = _a.name, placeholder = _a.placeholder, _b = _a.label, label = _b === void 0 ? "" : _b, LabelIcon = _a.labelIcon, _c = _a.value, value = _c === void 0 ? "" : _c, _d = _a.type, type = _d === void 0 ? "text" : _d, inputMode = _a.inputMode, _e = _a.multiRows, multiRows = _e === void 0 ? false : _e, _f = _a.rows, rows = _f === void 0 ? 1 : _f, _g = _a.focused, focused = _g === void 0 ? false : _g, PrependIcon = _a.prependIcon, prependLabel = _a.prependLabel, appendLabel = _a.appendLabel, _h = _a.appearance, appearance = _h === void 0 ? "default" : _h, helpText = _a.helpText, minLength = _a.minLength, maxLength = _a.maxLength, min = _a.min, max = _a.max, _j = _a.required, required = _j === void 0 ? false : _j, _k = _a.autoCapitalize, autoCapitalize = _k === void 0 ? false : _k, _l = _a.autoCorrect, autoCorrect = _l === void 0 ? false : _l, _m = _a.autoComplete, autoComplete = _m === void 0 ? "" : _m, _o = _a.disabled, disabled = _o === void 0 ? false : _o, _p = _a.readOnly, readOnly = _p === void 0 ? false : _p, _q = _a.autoSelect, autoSelect = _q === void 0 ? false : _q, onChange = _a.onChange, onSubmit = _a.onSubmit, onBlur = _a.onBlur, onFocus = _a.onFocus, _r = _a.lineThrough, lineThrough = _r === void 0 ? false : _r;
    var _s = React.useState(false), showPassword = _s[0], setsShowPassword = _s[1];
    if (prependLabel && PrependIcon) {
        throw new Error("You can not use parameters 'prependLabel' and 'prependIcon' simultaneously");
    }
    if ((prependLabel || appendLabel || PrependIcon) && type === "search") {
        throw new Error("You can not use parameters 'prependLabel' or 'appendLabel' or 'prependIcon' with type='search'");
    }
    var handleChange = function (event) {
        var target = event.target;
        onChange === null || onChange === void 0 ? void 0 : onChange({ name: target.name, value: target.value });
    };
    var handleFocus = function (event) {
        var _a;
        var target = event.target;
        onFocus === null || onFocus === void 0 ? void 0 : onFocus({ name: target.name, value: target.value });
        if (autoSelect)
            (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.select();
    };
    var handleBlur = function (event) {
        var target = event.target;
        onBlur === null || onBlur === void 0 ? void 0 : onBlur({ name: target.name, value: target.value });
    };
    var handleKeyPress = function (e) {
        if (e.key === "Enter" && type === "search") {
            e.preventDefault();
            onSubmit === null || onSubmit === void 0 ? void 0 : onSubmit({ name: name, value: value });
        }
    };
    var handleClose = function () {
        onSubmit === null || onSubmit === void 0 ? void 0 : onSubmit({ name: name, value: "" });
    };
    var handlePassword = function () {
        var _a;
        setsShowPassword(!showPassword);
        (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.focus();
    };
    var renderLabel = type !== "search" && label && (React.createElement("label", { className: "nimbus--input__label", htmlFor: "input_".concat(name) },
        LabelIcon && (React.createElement("div", { className: "nimbus--input__label-icon" },
            React.createElement(LabelIcon, null))),
        label));
    var prependClassname = (0, classnames_1.default)("nimbus--input__prepend", {
        "nimbus--input__error": appearance === "validation_error",
        "nimbus--input__success": appearance === "validation_success",
    });
    var appendClassname = (0, classnames_1.default)("nimbus--input__append", {
        "nimbus--input__error": appearance === "validation_error",
        "nimbus--input__success": appearance === "validation_success",
    });
    var renderPrependLabel = prependLabel && (React.createElement("span", { className: prependClassname }, prependLabel));
    var renderAppendLabel = appendLabel && (React.createElement("span", { className: appendClassname }, appendLabel));
    var renderLeftIcon = (PrependIcon || type === "search") && (React.createElement("span", { className: prependClassname },
        type === "search" && React.createElement(icons_1.SearchIcon, null),
        PrependIcon && React.createElement(PrependIcon, null)));
    var renderColorInput = type === "color" && (React.createElement("div", { className: "nimbus--input--color--container" },
        React.createElement("input", { type: "color", className: "nimbus--input--color", name: name, value: value, "data-testid": "inputField-color", onChange: handleChange })));
    var getIcon = function (iconType) {
        switch (iconType) {
            case "search":
                return (React.createElement("button", { type: "button", className: "nimbus--input__append nimbus--input__append__inside__icon", onClick: handleClose },
                    React.createElement(icons_1.CloseIcon, null)));
            case "error":
                return (React.createElement("span", { className: "nimbus--input__append nimbus--input__append__inside__icon" },
                    React.createElement(icons_1.ExclamationCircleIcon, null)));
            case "success":
                return (React.createElement("span", { className: "nimbus--input__append nimbus--input__append__inside__icon" },
                    React.createElement(icons_1.CheckCircleIcon, null)));
            case "password":
                return (React.createElement("button", { type: "button", className: "nimbus--input__append nimbus--input__password", onClick: handlePassword }, showPassword ? React.createElement(icons_1.EyeOffIcon, null) : React.createElement(icons_1.EyeIcon, null)));
            case "isLoading":
                return (React.createElement("span", { className: "nimbus--input__append nimbus--input__append__inside__icon nimbus--input__spinner" },
                    React.createElement(Spinner_1.Spinner, null)));
            default:
                return null;
        }
    };
    var handleType = type !== "search" && type !== "password";
    var renderRightIcon = (React.createElement(React.Fragment, null,
        type === "search" && value && getIcon("search"),
        type === "password" && value && getIcon("password"),
        handleType && appearance === "validation_error" && getIcon("error"),
        handleType && appearance === "validation_success" && getIcon("success"),
        handleType &&
            appearance === "validation_loading" &&
            getIcon("isLoading")));
    var newType = showPassword || type === "color" ? "text" : type;
    var classname = (0, classnames_1.default)("nimbus--input__field", {
        "with-prepend": renderLeftIcon,
        "with-append": type === "search" || type === "password",
        "with-color": type === "color",
        "with-line-through": lineThrough ? "with-line-through" : "",
    });
    var inputRef = React.useRef(null);
    var inputTextAreaRef = React.useRef(null);
    React.useEffect(function () {
        var input = (multiRows ? inputTextAreaRef.current : inputRef.current);
        if (focused)
            input.focus();
        else
            input.blur();
    }, [focused, multiRows]);
    var inputField = (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "nimbus--input" },
            multiRows && (React.createElement("textarea", { "data-testid": "textAreaField", className: "nimbus--input__field", id: "input_".concat(name), ref: inputTextAreaRef, name: name, inputMode: inputMode, value: value, placeholder: placeholder, rows: rows, autoCapitalize: autoCapitalize ? "on" : "off", autoCorrect: autoCorrect ? "on" : "off", autoComplete: autoComplete, onChange: handleChange, onBlur: handleBlur, onFocus: handleFocus, minLength: minLength, maxLength: maxLength, required: required, disabled: disabled, readOnly: readOnly })),
            !multiRows && (React.createElement(React.Fragment, null,
                React.createElement("input", { "data-testid": "inputField", className: classname, id: "input_".concat(name), name: name, type: newType, inputMode: inputMode, ref: inputRef, value: value, placeholder: placeholder, autoCapitalize: autoCapitalize ? "on" : "off", autoCorrect: autoCorrect ? "on" : "off", autoComplete: autoComplete, onChange: handleChange, onKeyPress: handleKeyPress, onBlur: handleBlur, onFocus: handleFocus, minLength: minLength, maxLength: maxLength, max: max, min: min, required: required, disabled: disabled, readOnly: readOnly }),
                renderLeftIcon,
                renderRightIcon,
                renderColorInput)))));
    var className = (0, classnames_1.default)("nimbus--input-wrapper", {
        "nimbus--input-validation--error": appearance === "validation_error",
        "nimbus--input--disabled": disabled,
        "nimbus--input--read-only": readOnly,
        "nimbus--input-validation--success": appearance === "validation_success",
        "nimbus--input-validation--loading": appearance === "validation_loading",
        "nimbus--input-danger": appearance === "danger",
        "nimbus--input-warning": appearance === "warning",
        "nimbus--input-success": appearance === "success",
    });
    var appearanceError = appearance === "validation_error" && "danger";
    var appearanceSuccess = appearance === "validation_success" && "success";
    var appearanceMessage = appearanceError || appearanceSuccess || "light";
    return (React.createElement("div", { className: className },
        renderLabel,
        renderPrependLabel || renderAppendLabel ? (React.createElement("div", { className: "nimbus--input__container" },
            renderPrependLabel,
            inputField,
            renderAppendLabel)) : (inputField),
        helpText && (React.createElement(Text_1.default, { block: true, size: "caption", appearance: appearanceMessage, textAlign: "left" }, helpText))));
}
function Skeleton(_a) {
    var _b = _a.rows, rows = _b === void 0 ? 1 : _b;
    var skeletonClassName = (0, classnames_1.default)("nimbus--input-skeleton", "rows-".concat(rows));
    return (React.createElement("div", { className: skeletonClassName },
        React.createElement("div", { className: "nimbus--input-skeleton__label" }),
        React.createElement("div", { className: "nimbus--input-skeleton__field" })));
}
Input.Skeleton = Skeleton;
exports.InputValidator = (0, validator_1.withValidator)(Input);
exports.default = Input;
//# sourceMappingURL=index.js.map